import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { DateRangeFilter, type DateRangeChange } from './filters/DateRangeFilter';

export function DashboardFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const department = searchParams.get('department') ?? '';

  const { data: deptsData } = useQuery({
    queryKey: ['departments-lookup'],
    queryFn: () => api.listDepartments(),
    staleTime: 5 * 60_000,
  });

  function handleDateChange(next: DateRangeChange) {
    const p = new URLSearchParams(searchParams);
    if (next.all) p.set('range', 'all');
    else p.delete('range');
    if (next.from) p.set('date_from', next.from);
    else p.delete('date_from');
    if (next.to) p.set('date_to', next.to);
    else p.delete('date_to');
    setSearchParams(p);
  }

  function setDepartment(value: string) {
    const next = new URLSearchParams(searchParams);
    if (value === '') next.delete('department');
    else next.set('department', value);
    setSearchParams(next);
  }

  return (
    <div className="space-y-2 rounded-lg border border-border bg-card p-3">
      <DateRangeFilter defaultPick="this-month" onChange={handleDateChange} />
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-muted-foreground">Bộ phận</span>
        <select
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          className="rounded border border-border bg-background px-2 py-1.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
        >
          <option value="">Tất cả bộ phận</option>
          <option value="unassigned">Chưa gán</option>
          {(deptsData?.rows ?? []).map((d) => (
            <option key={d.id} value={d.id}>
              {d.code} — {d.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
